var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09457 11.1225C1.61744 11.6243 0.625 13.0097 0.625 14.5698V16H4.39344L5.33095 15.375V10.9876L4.39344 10.6812L3.09457 11.1225Z",
    fill: "#2894C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9053 11.1225L11.6064 10.6812L10.6689 10.9876V15.375L11.6064 16H15.3749V14.5698C15.3749 13.0097 14.3825 11.6243 12.9053 11.1225Z",
    fill: "#2894C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6748 11.8204H9.3254V16H6.6748V11.8204Z",
    fill: "#2894C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.8204H9.32528V16H8V11.8204Z",
    fill: "#2894C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.021 9.95355L6.67481 12.7579H9.32541L9.97922 9.95355H6.021Z",
    fill: "#2894C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9791 9.95355H8V12.7579H9.32528L9.9791 9.95355Z",
    fill: "#2894C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46884 6.74586V7.68334H7.84384C6.60987 7.68334 5.60596 6.67943 5.60596 5.44546C5.60596 4.21149 6.60987 3.20758 7.84384 3.20758H8.46884V4.1451H8.46888V0.312501L8.00013 0H6.2396L5.96147 1.06866C5.61882 1.2161 5.29541 1.4031 4.99572 1.6271L3.92244 1.34666L2.33353 4.09876L3.11294 4.88798C3.09144 5.07257 3.08056 5.25923 3.08056 5.44545C3.08056 5.6317 3.09144 5.81839 3.11297 6.00304L2.3335 6.79226L3.92244 9.54436L4.99588 9.26389C5.2955 9.48786 5.61882 9.67477 5.96141 9.82221L6.2396 10.8911H8.00013L8.46888 10.5786V6.74586H8.46884Z",
    fill: "#2894C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6748 3.97675H11.5811V6.91425H12.6748C13.4847 6.91425 14.1436 6.25538 14.1436 5.4455C14.1436 4.63562 13.4847 3.97675 12.6748 3.97675Z",
    fill: "#2894C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5811 1.10974C11.5811 2.26649 10.64 3.20759 9.48325 3.20759H8.625L8 4.14509V10.8911H8.45606C10.6962 10.8911 12.5186 9.0686 12.5186 6.8285V1.10974H11.5811Z",
    fill: "#2894C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDev);
export default __webpack_public_path__ + "static/media/dev.654166bc2bcf6e36e0d37fe257cbc743.svg";
export { ForwardRef as ReactComponent };